<template>
  <Container class="Navbar">
    <LogoLink :url="homepagePath" class="logoLink" />
    <MenuButton
      class="menuButton"
      :isActive="isMenuShowing"
      @click="toggleMenu"
    />
  </Container>
</template>

<script>
import LogoLink from "../shared/LogoLink.vue";
import MenuButton from "../shared/MenuButton.vue";

export default {
  components: {
    LogoLink,
    MenuButton,
  },
  props: {
    homepagePath: String,
    toggleMenu: Function,
    isMenuShowing: Boolean,
  }
};
</script>

<style scoped>
.Navbar {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  height: var(--navbar-height);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: white;
}

.menuButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
}
</style>
